// import React from 'react';

// export function Form() {
//     return (
//         <>
//             <div className='form-container'>
//                 {/* Full Name */}
//                 {/* Phone Number */}
//                 {/* Email Address (Optional) */}
//                 {/* Which city is your restaurant based in? */}
//                 {/* Referred by a friend? Please enter their name and phone number below so you can start creating your private Unified Loyalty Network as soon as we launch. */}
//                 <header className='header'>
//                     <img src={require('./../imgs/loyaltea-logo.png')} alt='Loyaltea logo' className='header-logo' />
//                     <h1>Loyaltea</h1>
//                 </header>

//                 <section className='form-element-container'>
//                     <form className='waitlist-form'>
//                         <label className="visually-hidden" htmlFor="first-name">First Name</label>
//                         <input
//                             type="text"
//                             id="first-name"
//                             name="first-name"
//                             placeholder="First Name"
//                             // value={profile.firstName}
//                             // onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
//                             required
//                         />

//                         <label className="visually-hidden" htmlFor="last-name">Last Name</label>
//                         <input
//                             type="text"
//                             id="last-name"
//                             name="last-name"
//                             placeholder="Last Name"
//                             // value={profile.firstName}
//                             // onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
//                             required
//                         />

//                         <label className="visually-hidden" htmlFor="phone">Phone</label>
//                         <input
//                             type="text"
//                             id="phone"
//                             name="phone"
//                             placeholder="Phone Number"
//                             // value={profile.firstName}
//                             // onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
//                             required
//                             pattern="[0-9]{10}"
//                         />

//                         <label className="visually-hidden" htmlFor="email">Email Address (Optional)</label>
//                         <input
//                             type="text"
//                             id="email"
//                             name="email"
//                             placeholder="Email Address"
//                         // value={profile.firstName}
//                         // onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
//                         />


//                         <label className="visually-hidden" htmlFor="city">City / Town</label>
//                         <input
//                             type='text'
//                             id='city'
//                             name='city'
//                             // value={profile.city}
//                             // onChange={(e) => setProfile({ ...profile, city: e.target.value })}
//                             placeholder="City / Town"
//                             required
//                         />

//                         <label className="visually-hidden" htmlFor="state">State / UT</label>
//                         <select
//                             id='state'
//                             name='state'
//                             // value={profile.state}
//                             // onChange={(e) => setProfile({ ...profile, state: e.target.value })}
//                             required
//                         >
//                             <option value="">Select State</option>
//                             <option>Andhra Pradesh</option>
//                             <option>Arunachal Pradesh</option>
//                             <option>Assam</option>
//                             <option>Bihar</option>
//                             <option>Chhattisgarh</option>
//                             <option>Delhi</option>
//                             <option>Goa</option>
//                             <option>Gujarat</option>
//                             <option>Haryana</option>
//                             <option>Himachal Pradesh</option>
//                             <option>Jharkhand</option>
//                             <option>Karnataka</option>
//                             <option>Kerala</option>
//                             <option>Madhya Pradesh</option>
//                             <option>Maharashtra</option>
//                             <option>Manipur</option>
//                             <option>Meghalaya</option>
//                             <option>Mizoram</option>
//                             <option>Nagaland</option>
//                             <option>Odisha</option>
//                             <option>Punjab</option>
//                             <option>Rajasthan</option>
//                             <option>Sikkim</option>
//                             <option>Tamil Nadu</option>
//                             <option>Telangana</option>
//                             <option>Tripura</option>
//                             <option>Uttar Pradesh</option>
//                             <option>Uttarakhand</option>
//                             <option>West Bengal</option>
//                             <option>Andaman and Nicobar Islands</option>
//                             <option>Chandigarh</option>
//                             <option>Dadra and Nagar Haveli and Daman and Diu</option>
//                             <option>Jammu and Kashmir</option>
//                             <option>Ladakh</option>
//                             <option>Lakshadweep</option>
//                             <option>Puducherry</option>
//                         </select>

//                         <p>Referred by a friend? Please enter their name and phone number below so you can start creating your private Unified Loyalty Network as soon as we launch.</p>

//                         <label className="visually-hidden" htmlFor="referrer-first-name">Referrer First Name</label>
//                         <input
//                             type="text"
//                             id="referrer-first-name"
//                             name="referrer-first-name"
//                             placeholder="Referrer First Name"
//                             // value={profile.firstName}
//                             // onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
//                         />

//                         <label className="visually-hidden" htmlFor="referrer-last-name">Referrer Last Name</label>
//                         <input
//                             type="text"
//                             id="referrer-last-name"
//                             name="referrer-last-name"
//                             placeholder="Referrer Last Name"
//                             // value={profile.firstName}
//                             // onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
//                         />

//                         <label className="visually-hidden" htmlFor="phone">Referrer Phone</label>
//                         <input
//                             type="text"
//                             id="referrer-phone"
//                             name="referrer-phone"
//                             placeholder="Referrer Phone Number"
//                             // value={profile.firstName}
//                             // onChange={(e) => setProfile({ ...profile, firstName: e.target.value })}
//                             pattern="[0-9]{10}"
//                         />

//                         <button id='submit-button'>Submit</button>
//                     </form>
//                 </section>
//             </div>
//         </>
//     )
// }

import React, { useState } from "react";
import { ref, push, set } from "firebase/database";
import { db } from "./../firebase.js";
import { useNavigate } from "react-router-dom";

export function Form() {

    // IMPORTANT: keys match input `name` attributes exactly
    const [formState, setFormState] = useState({
        "first-name": "",
        "last-name": "",
        "phone": "",
        "email": "",
        "city": "",
        "state": "",
        "referrer-first-name": "",
        "referrer-last-name": "",
        "referrer-phone": ""
    });

    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormState((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("In the handleSubmit function");

        try {
            const waitlistRef = ref(db, "waitlist");
            const newEntryRef = push(waitlistRef);

            await set(newEntryRef, {
                ...formState,
                createdAt: Date.now()
            });

            // Redirect to success page
            navigate("/success");

        } catch (error) {
            console.error("Error saving waitlist data:", error);
            alert("Something went wrong. Please try again.");
        }
    };

    return (
        <>
            <div className='form-container'>
                <header className='header'>
                    <img
                        src={require('./../imgs/loyaltea-logo.png')}
                        alt='Loyaltea logo'
                        className='header-logo'
                    />
                    <h1>Loyaltea</h1>
                </header>

                <section className='form-element-container'>
                    <form className='waitlist-form' onSubmit={handleSubmit}>

                        <label className="visually-hidden" htmlFor="first-name">First Name</label>
                        <input
                            type="text"
                            id="first-name"
                            name="first-name"
                            placeholder="First Name"
                            onChange={handleChange}
                            required
                        />

                        <label className="visually-hidden" htmlFor="last-name">Last Name</label>
                        <input
                            type="text"
                            id="last-name"
                            name="last-name"
                            placeholder="Last Name"
                            onChange={handleChange}
                            required
                        />

                        <label className="visually-hidden" htmlFor="phone">Phone</label>
                        <input
                            type="text"
                            id="phone"
                            name="phone"
                            placeholder="Phone Number"
                            onChange={handleChange}
                            required
                            pattern="[0-9]{10}"
                        />

                        <label className="visually-hidden" htmlFor="email">Email Address (Optional)</label>
                        <input
                            type="text"
                            id="email"
                            name="email"
                            placeholder="Email Address"
                            onChange={handleChange}
                        />

                        <label className="visually-hidden" htmlFor="city">City / Town</label>
                        <input
                            type='text'
                            id='city'
                            name='city'
                            placeholder="City / Town"
                            onChange={handleChange}
                            required
                        />

                        <label className="visually-hidden" htmlFor="state">State / UT</label>
                        <select
                            id='state'
                            name='state'
                            onChange={handleChange}
                            required
                        >
                            <option value="">Select State</option>
                            <option>Andhra Pradesh</option>
                            <option>Arunachal Pradesh</option>
                            <option>Assam</option>
                            <option>Bihar</option>
                            <option>Chhattisgarh</option>
                            <option>Delhi</option>
                            <option>Goa</option>
                            <option>Gujarat</option>
                            <option>Haryana</option>
                            <option>Himachal Pradesh</option>
                            <option>Jharkhand</option>
                            <option>Karnataka</option>
                            <option>Kerala</option>
                            <option>Madhya Pradesh</option>
                            <option>Maharashtra</option>
                            <option>Manipur</option>
                            <option>Meghalaya</option>
                            <option>Mizoram</option>
                            <option>Nagaland</option>
                            <option>Odisha</option>
                            <option>Punjab</option>
                            <option>Rajasthan</option>
                            <option>Sikkim</option>
                            <option>Tamil Nadu</option>
                            <option>Telangana</option>
                            <option>Tripura</option>
                            <option>Uttar Pradesh</option>
                            <option>Uttarakhand</option>
                            <option>West Bengal</option>
                            <option>Andaman and Nicobar Islands</option>
                            <option>Chandigarh</option>
                            <option>Dadra and Nagar Haveli and Daman and Diu</option>
                            <option>Jammu and Kashmir</option>
                            <option>Ladakh</option>
                            <option>Lakshadweep</option>
                            <option>Puducherry</option>
                        </select>

                        <p>
                            Referred by a friend? Please enter their name and phone number below
                            so you can start creating your private Unified Loyalty Network as soon as we launch.
                        </p>

                        <label className="visually-hidden" htmlFor="referrer-first-name">Referrer First Name</label>
                        <input
                            type="text"
                            id="referrer-first-name"
                            name="referrer-first-name"
                            placeholder="Referrer First Name"
                            onChange={handleChange}
                        />

                        <label className="visually-hidden" htmlFor="referrer-last-name">Referrer Last Name</label>
                        <input
                            type="text"
                            id="referrer-last-name"
                            name="referrer-last-name"
                            placeholder="Referrer Last Name"
                            onChange={handleChange}
                        />

                        <label className="visually-hidden" htmlFor="referrer-phone">Referrer Phone</label>
                        <input
                            type="text"
                            id="referrer-phone"
                            name="referrer-phone"
                            placeholder="Referrer Phone Number"
                            onChange={handleChange}
                            pattern="[0-9]{10}"
                        />

                        <button type="submit" id='submit-button'>Submit</button>
                    </form>
                </section>
            </div>
        </>
    );
}